import { createFileRoute } from '@tanstack/react-router';
import { SpecRouteComponent } from './spec.js';

export const Route = createFileRoute('/$workspaceSlug/spec')({
  component: SpecRouteComponent,
});
